import api from "./Api";

class OrdemServicoAnexoService {
  GetOrdemServicoAnexo(payload) {
    return api.get("/v1/ordemServicoAnexo/" + payload).then((response) => {
      return response.data;
    });
  }

  PostOrdemServicoAnexo(payload) {
    return api.post("/v1/ordemServicoAnexo/", payload).then((response) => {
      return response.data;
    });
  }

  PutOrdemServicoAnexo(payload) {
    return api.put("/v1/ordemServicoAnexo/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteOrdemServicoAnexo(payload) {
    return api.delete("/v1/ordemServicoAnexo/" + payload).then((response) => {
      return response.data;
    });
  }

  GetOrdemServicoAnexoOData(payload) {
    return api.get("/OData/OrdemServicoAnexo" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new OrdemServicoAnexoService();
